(function(){
  if (window.__MB_LP_INIT__) return;
  window.__MB_LP_INIT__ = true;
  var chosen = false;
  var C = window.MB_CONFIG || {}, M = window.MB_MEDIA || {}, L = window.MB_LINKS || {};
  var R = window.MB_REVIEWS_CONFIRMED === true ? (window.MB_REVIEWS || []) : [];
  var ss = { get:function(k){ try{ return sessionStorage.getItem(k); }catch(e){ return null; } }, set:function(k,v){ try{ sessionStorage.setItem(k,v); }catch(e){} } };
  if (!ss.get('mb_first')) ss.set('mb_first', C.lpTag);
  var seen = (ss.get('mb_seen')||'').split(',').filter(Boolean); if (seen.indexOf(C.lpTag)<0){ seen.push(C.lpTag); ss.set('mb_seen', seen.join(',')); }
  if (C.lpTag && String(C.lpTag).indexOf('lp-marketing') === 0){
    ss.set('mb_funnel', 'marketing');
    if (/\/products\//.test(location.pathname)) ss.set('mb_marketing_purchase', location.pathname + location.search);
  }
  var qs0 = new URLSearchParams(location.search);
  ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid','gclid'].forEach(function(k){ if (qs0.get(k)) ss.set('mb_'+k, qs0.get(k)); });
  var models = (C.models || []).slice(), preview = !!C.preview;
  var $ = function(s, r){ return (r||document).querySelector(s); };
  var $$ = function(s, r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); };
  function track(n,d){ try{ (window.dataLayer=window.dataLayer||[]).push(Object.assign({event:n, lp:C.lpTag}, d||{})); }catch(e){} }
  function ytId(u){ if (!u) return null; var m = String(u).match(/(?:youtu\.be\/|[?&]v=|\/embed\/|\/shorts\/)([A-Za-z0-9_-]{11})/); if (m) return m[1]; return /^[A-Za-z0-9_-]{11}$/.test(u) ? u : null; }
  // YouTube: show a lightweight poster first; the player (privacy-enhanced, no cookies until play) loads only on tap
  function ytFacade(id, poster, title){
    var b = document.createElement('button'); b.type = 'button'; b.className = 'yt'; b.setAttribute('aria-label', 'Play video: ' + title);
    b.innerHTML = '<img alt="" src="' + (poster || ('https://i.ytimg.com/vi/' + id + '/hqdefault.jpg')) + '"><span class="pl" aria-hidden="true"></span><span class="yt-note">Plays from YouTube</span>';
    b.addEventListener('click', function(){
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1&cc_load_policy=1';
      f.title = title; f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true;
      b.replaceWith(f); track('mb_video_play', {video: id, title: title});
    });
    return b;
  }
  var FN = [];
  function footnote(text){ var i = FN.indexOf(text); if (i < 0){ FN.push(text); i = FN.length - 1; } return i + 1; }
  function sup(n){ var s = document.createElement('sup'); s.className = 'fnref'; var a = document.createElement('a'); a.href = '#fn-' + n; a.id = 'fnref-' + n + '-' + Math.random().toString(36).slice(2,6); a.textContent = n; a.setAttribute('aria-label', 'Note ' + n); s.appendChild(a); return s; }
  function money(c){ try { return new Intl.NumberFormat('en-US',{style:'currency',currency:C.currency||'USD'}).format(c/100); } catch(e){ return '$'+(c/100).toFixed(2); } }

  /* broken image fallback: keep the warm block, hide the broken icon */
  $$('.mb img').forEach(function(i){ function x(){ i.style.visibility='hidden'; } if (i.complete && i.naturalWidth===0 && i.getAttribute('src')) x(); i.addEventListener('error', x); });

  /* ---------- model data ---------- */
  var SPEC = {
    elite: {name:'Pro Elite', desc:'15 levels with + and \u2212. Starts on medium.', levels:'15', lvlLabel:'levels', controls:'+ and \u2212', start:'Medium', tag:'Most control'},
    pro2:  {name:'Pro 2', desc:'3 speeds on one button. More power than Pro.', levels:'3', lvlLabel:'speeds', controls:'One button', start:'Low', tag:''},
    pro:   {name:'Pro', desc:'3 speeds on one button. The original.', levels:'3', lvlLabel:'speeds', controls:'One button', start:'Low', tag:''}
  };
  function keyOf(t){ t = t || ''; if (/elite|2\s*\+|plus/i.test(t)) return 'elite'; if (/pro\s*2/i.test(t)) return 'pro2'; if (/pro/i.test(t)) return 'pro'; return 'elite'; }
  models.forEach(function(m){
    if (!m.key) m.key = (!m.title || m.title === 'Default Title') ? 'pro' : keyOf(m.title);
    m.label = (SPEC[m.key] && SPEC[m.key].name) || m.title || 'Pro';
  });
  models = models.filter(function(m){ return m.key === 'pro' || m.key === 'elite'; }); // this page sells Pro and Pro Elite only
  models.sort(function(a,b){ var o = {pro:1, elite:2}; return (o[a.key]||9) - (o[b.key]||9); });
  models.forEach(function(m){ if (!m.image) m.image = (C.modelThumbs||{})[m.key] || C.thumb; });
  function marketingExplain(url){
    if (!url) return null;
    var path = String(url).split('#')[0];
    var base = path.split('?')[0];
    var params = new URLSearchParams(path.indexOf('?') >= 0 ? path.slice(path.indexOf('?') + 1) : '');
    params.delete('view');
    params.set('view', 'myobuddy-massager-lp');
    return base + '?' + params.toString();
  }
  if (ss.get('mb_funnel') === 'marketing' && L){
    var purchase = ss.get('mb_marketing_purchase');
    if (purchase){ L.purchase = purchase.split('#')[0]; L.explain = marketingExplain(purchase); }
    if (L.marketingHome) L.home = L.marketingHome;
  }
  var sel = 0;
  /* Preselect MyoBuddy Pro (not Pro Elite). Honour ?variant= / ?model= when present. */
  models.forEach(function(m,i){ if (m.key==='pro' && m.available!==false) sel=i; });
  var wantVariant = qs0.get('variant');
  if (wantVariant){ models.some(function(m,i){ if (String(m.id)===String(wantVariant) && m.available!==false){ sel=i; return true; } }); }
  else {
    var want = qs0.get('model');
    if (want){ models.some(function(m,i){ if (m.key===want && m.available!==false){ sel=i; return true; } }); }
  }
  if (qs0.get('qty')){ var qn = parseInt(qs0.get('qty'),10); if (qn>=1 && qn<=5) window.__mbq = qn; }
  if (models[sel] && models[sel].available===false){ models.some(function(m,i){ if (m.available!==false){ sel=i; return true; } }); }
  if (models[sel]) chosen = true; /* Pro (or matched variant) is preselected */
  var qty = window.__mbq || 1, addon = (C.addon && C.addon.id !== null && C.addon.available !== false) ? C.addon : null, addonOn = false;

  function syncModelUrl(m){
    if (!m || !m.id) return;
    try {
      var u = new URL(location.href);
      u.searchParams.set('variant', String(m.id));
      u.searchParams.delete('model');
      var next = u.pathname + u.search + (location.hash || '');
      if (next !== location.pathname + location.search + location.hash) history.replaceState({ mbVariant: m.id }, '', next);
    } catch(e){}
  }
  if (models[sel] && models[sel].id && !qs0.get('variant')) syncModelUrl(models[sel]);

  /* ---------- model cards ---------- */
  var list = $('#models');
  if (list){
    models.forEach(function(m,i){
      var b = document.createElement('button');
      b.type='button'; b.className='model'; b.setAttribute('role','radio');
      if (m.available===false) b.setAttribute('aria-disabled','true');
      b.innerHTML = '<img src="'+(m.image||C.thumb||'')+'" alt=""><span><b>MyoBuddy '+m.label+'</b><small>'+SPEC[m.key].desc+'</small>'+(m.available===false?'<small class="so">Sold out</small>':'')+'</span><span class="mp">'+m.price+'</span>';
      b.addEventListener('click', function(){ if (m.available===false) return; sel=i; chosen = true; syncModelUrl(models[sel]); paint(); track('mb_model_select',{model:m.label}); });
      list.appendChild(b);
    });
    if (models.length < 2){ $$('[data-if-multi]').forEach(function(e){ e.hidden = true; }); }
  }

  /* ---------- model comparison (secondary) ---------- */
  var mc = $('#mcmp');
  if (mc){
    var keys = ['pro','elite'].filter(function(k){ return models.some(function(m){ return m.key===k; }); });
    if (keys.length < 2){ var s = $('#models-compare'); if (s) s.hidden = true; $$('a[href="#models-compare"]').forEach(function(a){ a.hidden = true; if (a.parentNode.tagName==='LI') a.parentNode.hidden = true; }); }
    else {
      mc.style.setProperty('--cols', keys.length);
      keys.forEach(function(k){
        var sp = SPEC[k], m = models.filter(function(x){ return x.key===k; })[0];
        var col = document.createElement('div'); col.className = 'col' + (k==='elite' ? ' pick' : '');
        col.innerHTML = '<span class="tag'+(sp.tag?'':' blank')+'">'+(sp.tag||'.')+'</span><h3>'+sp.name+'</h3><p class="pr">'+(m?m.price:'')+'</p>'+
          '<dl><dt>'+sp.levels+'</dt><dd>'+sp.lvlLabel+'</dd><dt>'+sp.controls+'</dt><dd>controls</dd><dt>'+sp.start+'</dt><dd>starts on</dd></dl>';
        var btn = document.createElement(m ? 'button' : 'span');
        if (m){ btn.type='button'; btn.className = 'btn ' + (k==='elite' ? '' : 'light'); btn.textContent = 'Choose ' + sp.name;
          btn.addEventListener('click', function(){ sel = models.indexOf(m); chosen = true; syncModelUrl(models[sel]); paint(); var bb = $('#buy'); if (bb) bb.scrollIntoView({behavior:'smooth', block:'start'}); }); }
        col.appendChild(btn); mc.appendChild(col);
      });
    }
  }

  /* ---------- add-on ---------- */
  var addBoxes = $$('.addon');
  if (addon){
    addBoxes.forEach(function(l){ l.hidden = false; $('.ap', l).textContent = '+' + addon.price;
      $('input', l).addEventListener('change', function(e){ addonOn = e.target.checked; paint(); track('mb_addon_toggle',{on:addonOn}); }); });
  } else { addBoxes.forEach(function(l){ l.hidden = true; }); $$('[data-if-addon]').forEach(function(e){ e.hidden = true; }); }

  /* ---------- quantity ---------- */
  $$('.qty').forEach(function(q){
    $('[data-q="-"]', q).addEventListener('click', function(){ if (qty>1){ qty--; paint(); } });
    $('[data-q="+"]', q).addEventListener('click', function(){ if (qty<5){ qty++; paint(); } });
  });

  function total(){ var m = models[sel]; if (!m || typeof m.cents!=='number') return m ? m.price : ''; return money(m.cents*qty + (addonOn && addon ? addon.cents : 0)); }
  function paint(){
    var m = models[sel] || {};
    if (list) $$('.model', list).forEach(function(b,i){ b.setAttribute('aria-checked', i===sel?'true':'false'); });
    $$('[data-price]').forEach(function(e){ e.textContent = m.price || ''; });
    $$('[data-name]').forEach(function(e){ e.textContent = 'MyoBuddy ' + (m.label || 'Pro'); });
    var lv = {elite:'15 levels on Pro Elite, set with + and \u2212.', pro:'3 speeds on Pro, on one button.'};
    $$('[data-levels]').forEach(function(e){ e.textContent = lv[m.key] || lv.elite; });
    var cheapest = models.reduce(function(a2, b2){ return (typeof b2.cents === 'number' && (!a2 || b2.cents < a2.cents)) ? b2 : a2; }, null);
    var cheapestLabel = cheapest ? cheapest.price : '';
    $$('[data-mpick-wrap]').forEach(function(w){ if (!$('[data-mpick]', w)) { var d = el('div','mpick'); d.setAttribute('role','radiogroup'); d.setAttribute('aria-label','Choose your model'); d.setAttribute('data-mpick',''); w.appendChild(d); } });
    $$('[data-mpick]').forEach(function(box){
      if (!box.children.length && models.length){
        models.forEach(function(mm, i){
          var btn = el('button', 'mp-opt'); btn.type = 'button'; btn.setAttribute('role','radio'); btn.setAttribute('aria-checked','false');
          btn.innerHTML = '<b>' + (mm.label || mm.title) + '</b><span>' + (mm.price || '') + '</span>';
          if (mm.available === false){ btn.disabled = true; btn.title = 'Sold out'; }
          btn.addEventListener('click', function(){ sel = i; chosen = true; syncModelUrl(models[sel]); paint(); track('mb_model_select', {model: mm.key, where: box.closest('#sticky') ? 'sticky' : (box.closest('.final') ? 'closing' : 'hero')}); });
          box.appendChild(btn);
        });
      }
      $$('.mp-opt', box).forEach(function(b2, i){ b2.setAttribute('aria-checked', (chosen && i === sel) ? 'true' : 'false'); });
      box.classList.toggle('none-picked', !chosen);
    });
    var choiceTarget = ($('#buy') ? '#buy' : ($('#compare') ? '#compare' : null));
    $$('[data-needs-choice]').forEach(function(btn){
      var pick = !chosen;
      btn.classList.toggle('is-pick', pick);
      var st2 = btn.closest('#sticky');
      if (pick){
        btn.textContent = st2 ? 'Choose model' : 'Choose your model';
        btn.setAttribute('aria-label', 'Choose your model, then add to cart');
      } else { btn.removeAttribute('aria-label'); }
    });
    var stEl = $('#sticky');
    if (stEl){
      var nm = $('[data-name]', stEl), pr = $('.sk-price', stEl);
      if (nm){ nm.textContent = chosen ? ('MyoBuddy ' + (m.label || m.title || '')) : ''; nm.hidden = !chosen; }
      var dv = $('.sk-div', stEl); if (dv) dv.hidden = !chosen;
      if (pr && !chosen && cheapestLabel) pr.textContent = 'From ' + cheapestLabel;
    }

    $$('[data-price-from]').forEach(function(e){ if (cheapest) e.textContent = cheapest.price; });
    $$('[data-model-price]').forEach(function(e){ var mm = models.filter(function(x){ return x.key === e.getAttribute('data-model-price'); })[0]; e.textContent = mm ? mm.price : ''; });
    $$('[data-sel]').forEach(function(e){ e.textContent = 'MyoBuddy ' + (m.label||'') + ', qty ' + qty + (addonOn && addon ? ', plus spare covers' : ''); });
    $$('.qty').forEach(function(q){ $('output', q).textContent = qty; $('[data-q="-"]', q).disabled = qty<=1; $('[data-q="+"]', q).disabled = qty>=5; });
    $$('.addon input').forEach(function(i){ i.checked = addonOn; });
    $$('[data-buy]').forEach(function(b){
      if (b.getAttribute('aria-busy')==='true' || b.hasAttribute('data-model')) return;
      if (b.hasAttribute('data-needs-choice') && !chosen){ b.disabled = false; return; }
      if (m.available===false || !models.length){ b.disabled = true; b.textContent = 'Sold out'; return; }
      b.disabled = false;
      b.textContent = (b.getAttribute('data-label')||'Add to cart') + (b.hasAttribute('data-show-price') ? ' \u2014 ' + total() : '');
    });
  }
  paint();

  /* ---------- attribution into cart attributes (landing variant + UTMs) ---------- */
  function attributes(){
    var a = {mb_landing: ss.get('mb_first') || C.lpTag, mb_added_on: C.lpTag, mb_pages_seen: (ss.get('mb_seen')||C.lpTag)};
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid','gclid'].forEach(function(k){ var v = qs0.get(k) || ss.get('mb_'+k); if (v) a['mb_'+k] = v; });
    return a;
  }

  /* ---------- cart drawer ---------- */
  var drawer = $('#drawer'), scrim = $('#scrim'), lastFocus = null;
  function openDrawer(cart){
    var box = $('.items', drawer); box.innerHTML = '';
    (cart.items||[]).forEach(function(it){
      var row = document.createElement('div'); row.className = 'it';
      row.innerHTML = '<img src="'+(it.image||C.thumb||'')+'" alt=""><div><b>'+it.product_title+'</b><small>'+(it.variant_title && it.variant_title!=='Default Title' ? it.variant_title+' \u00b7 ' : '')+'Qty '+it.quantity+'</small><button class="rm" type="button">Remove</button></div><span class="lp">'+money(it.final_line_price)+'</span>';
      $('.rm', row).addEventListener('click', function(){ removeItem(it.key); });
      box.appendChild(row);
    });
    if (!(cart.items||[]).length) box.innerHTML = '<p class="muted" style="padding:20px 0">Your cart is empty.</p>';
    $('#dr-sub').textContent = money(cart.total_price||0);
    $('#dr-checkout').hidden = !(cart.items||[]).length;
    lastFocus = document.activeElement;
    drawer.classList.add('show'); scrim.classList.add('show'); drawer.setAttribute('aria-hidden','false');
    $('.x', drawer).focus();
  }
  function closeDrawer(){ drawer.classList.remove('show'); scrim.classList.remove('show'); drawer.setAttribute('aria-hidden','true'); if (lastFocus) lastFocus.focus(); }
  if (drawer){
    $('.x', drawer).addEventListener('click', closeDrawer); scrim.addEventListener('click', closeDrawer);
    $('#dr-keep').addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function(e){ if (e.key==='Escape' && drawer.classList.contains('show')) closeDrawer(); });
    $('#dr-checkout').addEventListener('click', function(e){ track('mb_checkout_click'); if (preview){ e.preventDefault(); alert('Preview: this goes to Shopify checkout on the live page.'); } });
  }
  var pcart = {items:[], total_price:0};
  function previewAdd(items){
    items.forEach(function(x){
      var isAdd = addon && x.id === addon.id && x.isAddon;
      var m = models[sel];
      var it = {key:String(Math.random()), product_title: isAdd ? 'Blue Lotion Bonnet' : 'MyoBuddy '+m.label, variant_title: isAdd ? '2-pack' : '', quantity:x.quantity, final_line_price:(isAdd?addon.cents:m.cents)*x.quantity, image: isAdd ? '' : (m.image||C.thumb)};
      pcart.items.push(it);
    });
    pcart.total_price = pcart.items.reduce(function(s,i){ return s+i.final_line_price; },0);
    return Promise.resolve(pcart);
  }
  function getCart(){ return preview ? Promise.resolve(pcart) : fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }); }
  function removeItem(key){
    if (preview){ pcart.items = pcart.items.filter(function(i){ return i.key!==key; }); pcart.total_price = pcart.items.reduce(function(s,i){ return s+i.final_line_price; },0); openDrawer(pcart); return; }
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:0})})
      .then(function(r){ return r.json(); }).then(openDrawer).catch(function(){ location.href='/cart'; });
  }

  /* ---------- add to cart ---------- */
  var busy = false;
  $$('[data-buy]').forEach(bindBuy);
  function bindBuy(btn){
    btn.addEventListener('click', function(e){
      if (btn.hasAttribute('data-needs-choice') && !chosen){
        e.preventDefault();
        var near = btn.closest('#sticky, .final, .hero');
        var pick = near ? $('[data-mpick]', near) : null;
        if (pick){
          var opt = $('.mp-opt:not([disabled])', pick);
          pick.classList.add('flash'); setTimeout(function(){ pick.classList.remove('flash'); }, 1200);
          if (opt) opt.focus({preventScroll: true});
          track('mb_choose_model_prompt', {from: btn.closest('#sticky') ? 'sticky' : 'button'});
          return;
        }
        var tgt = $('#buy') || $('#compare') || $('#mcards');
        if (tgt){
          var y = tgt.getBoundingClientRect().top + window.scrollY - 104;
          window.scrollTo({top: Math.max(0, y), behavior: 'smooth'});
          var first = $('#models .model, .cmp-buy', tgt); if (first) setTimeout(function(){ first.focus({preventScroll: true}); }, 600);
        }
        track('mb_choose_model_prompt', {from: btn.closest('#sticky') ? 'sticky' : 'button'});
        return;
      }
      if (btn.hasAttribute('data-model')){ chosen = true; var mk = btn.getAttribute('data-model'); models.forEach(function(x,i){ if (x.key === mk) sel = i; }); paint(); }
      var m = models[sel]; if (busy || btn.disabled || !m) return;
      var holder = btn.closest('[data-buybox]'), msg = holder ? $('.msg', holder) : null; if (msg) msg.textContent = '';
      var items = [{id: m.id, quantity: qty, properties:{_lp: C.lpTag}}];
      if (addonOn && addon) items.push({id: addon.id, quantity:1, properties:{_lp: C.lpTag}, isAddon:true});
      busy = true; btn.setAttribute('aria-busy','true'); btn.textContent = 'Adding\u2026';
      var keepLbl = btn.hasAttribute('data-model') ? btn.getAttribute('data-label') : null;
      var done = function(){ busy = false; btn.removeAttribute('aria-busy'); if (keepLbl) btn.textContent = keepLbl; paint(); };
      var req;
      if (preview){ req = previewAdd(items); }
      else {
        var body = {items: items.map(function(x){ return {id:Number(x.id), quantity:x.quantity, properties:x.properties}; })};
        req = fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
          .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw new Error(j.description || j.message || 'error'); return j; }); })
          .then(function(){ return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes: attributes()})}).catch(function(){}); })
          .then(getCart);
      }
      req.then(function(cart){
        track('mb_add_to_cart_success',{model:m.label, variant:m.id, quantity:qty, addon:addonOn, value: typeof m.cents==='number' ? (m.cents*qty + (addonOn&&addon?addon.cents:0))/100 : null});
        done(); openDrawer(cart);
      }).catch(function(err){
        done(); if (msg) msg.textContent = 'We couldn\u2019t add that to your cart' + (err && err.message && err.message!=='error' ? ': ' + err.message : '') + '. Please try again.';
        track('mb_add_to_cart_error',{error: String(err && err.message)});
      });
    });
  }

  function starsHTML(avg){ return '<span class="bg">\u2605\u2605\u2605\u2605\u2605</span><span class="fg" style="width:' + (avg/5*100).toFixed(1) + '%">\u2605\u2605\u2605\u2605\u2605</span>'; }

  /* ---------- home: product cards ---------- */
  var hmGrid = $('#hm-grid');
  if (hmGrid && models.length){
    models.forEach(function(mm, i){
      var big = (C.modelLarge || {})[mm.key] || mm.image;
      var card = el('div','hm-card');
      card.innerHTML = '<div class="hm-ph"><img alt="" loading="lazy"></div><div class="hm-b"><h3></h3><p class="hm-d"></p>' +
        '<p class="hm-p"></p><button class="btn hm-add" type="button">Add to cart</button>' +
        '<a class="link hm-more" href="#">See details</a></div>';
      var img = $('img', card); img.src = big; img.alt = 'MyoBuddy ' + (mm.label || mm.title);
      $('h3', card).textContent = 'MyoBuddy ' + (mm.label || mm.title);
      $('.hm-d', card).textContent = /elite/i.test(mm.key) ? '15 intensity levels, set with plus and minus. Starts on medium.' : '3 speeds on one button. The original.';
      $('.hm-p', card).textContent = mm.price || '';
      var more = $('.hm-more', card); more.setAttribute('data-goto','purchase'); more.setAttribute('data-hash','buy');
      var add = $('.hm-add', card);
      add.setAttribute('data-buy',''); add.setAttribute('data-model', mm.key); add.setAttribute('data-label','Add to cart');
      if (mm.available === false){ add.disabled = true; add.textContent = 'Sold out'; }
      hmGrid.appendChild(card); bindBuy(add);
    });
  }

  /* ---------- home: short proof strip ---------- */
  var pf = $('#pf-grid');
  if (pf){
    var rt = C.shopRating || {}, rtc = window.MB_RATING || {}, av = rtc.average || rt.average, ct = rtc.count || rt.count;
    if (av){
      var rcard = el('div','pf-card pf-rating');
      rcard.innerHTML = '<p class="pf-n">' + av + '</p><p class="pf-s t-stars">' + starsHTML(av) + '</p><p class="pf-c">' + (ct ? ct + ' reviews' : 'Rated by owners') + '</p>';
      pf.appendChild(rcard);
    }
    (R.length ? R : []).slice(0, 2).forEach(function(r){
      var c2 = el('div','pf-card');
      c2.innerHTML = '<p class="pf-q"></p><p class="pf-w"></p>';
      $('.pf-q', c2).textContent = '\u201C' + (r.title || r.text) + '\u201D';
      $('.pf-w', c2).textContent = r.name + (r.model ? ' \u00B7 MyoBuddy ' + r.model : '');
      pf.appendChild(c2);
    });
    var used = Math.min(2, R.length), room = Math.max(0, 3 - 1 - used);
    var V2 = (window.MB_VOICES || []).filter(function(v){ return v.approved; });
    V2.slice(0, room).forEach(function(v){
      var c3 = el('div','pf-card');
      c3.innerHTML = '<p class="pf-q"></p><p class="pf-w"></p>';
      $('.pf-q', c3).textContent = '\u201C' + v.quote + '\u201D';
      $('.pf-w', c3).textContent = v.name + (v.title ? ' \u00B7 ' + v.title : '') + (v.label ? ' (' + v.label + ')' : '');
      pf.appendChild(c3);
    });
    if (!pf.children.length) { var sec = pf.closest('section'); if (sec) sec.hidden = true; }
  }

  /* ---------- accessories cross-sell ---------- */
  var AC = (C.accessories || []).filter(function(a){ return a && a.variants && a.variants.length; }), ag = $('#acc-grid');
  if (ag && AC.length){
    $('#accessories').hidden = false;
    AC.forEach(function(a, ai){
      var vs = a.variants, cur = 0; vs.some(function(v,i){ if (v.available !== false){ cur = i; return true; } });
      var card = el('div','acc-card');
      card.innerHTML = '<div class="acc-img"><img alt="" loading="lazy"></div><div class="acc-b"><div class="acc-top"><h3></h3><p class="acc-pr"></p></div><p class="acc-desc"></p><div class="acc-pills" role="radiogroup"></div><button class="btn acc-add" type="button">Add to cart</button><div class="msg" role="status" aria-live="polite"></div></div>';
      $('img', card).src = a.image; $('img', card).alt = a.title; $('h3', card).textContent = a.title; $('.acc-desc', card).textContent = a.desc || '';
      var pills = $('.acc-pills', card);
      function upd(){ $('.acc-pr', card).textContent = vs[cur].price || ''; $$('button', pills).forEach(function(b,i){ b.setAttribute('aria-checked', i===cur ? 'true' : 'false'); });
        var ad = $('.acc-add', card); ad.disabled = vs[cur].available === false; ad.textContent = ad.disabled ? 'Sold out' : 'Add to cart'; }
      if (vs.length > 1 || (vs[0].title && vs[0].title !== 'Default Title' && vs[0].title !== '8 oz')){
        vs.forEach(function(v,i){ var p = el('button', null, String(v.title).replace(/^(\d+)\s*bonnets?$/i, '$1-pack')); p.type = 'button'; p.setAttribute('role','radio'); if (v.available === false) p.disabled = true;
          p.addEventListener('click', function(){ cur = i; upd(); }); pills.appendChild(p); });
      } else pills.remove();
      var add = $('.acc-add', card), msg = $('.msg', card);
      add.addEventListener('click', function(){
        if (busy || add.disabled) return; var v = vs[cur]; msg.textContent = '';
        busy = true; add.setAttribute('aria-busy','true'); add.textContent = 'Adding\u2026';
        var fin = function(){ busy = false; add.removeAttribute('aria-busy'); upd(); };
        var req;
        if (preview){
          var cents = v.price ? Math.round(parseFloat(v.price.replace(/[^0-9.]/g,''))*100) : 0;
          pcart.items.push({key:String(Math.random()), product_title:a.title, variant_title:v.title, quantity:1, final_line_price:cents, image:a.image});
          pcart.total_price = pcart.items.reduce(function(s,i){ return s+i.final_line_price; },0); req = Promise.resolve(pcart);
        } else {
          req = fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(v.id),quantity:1,properties:{_lp:C.lpTag}}]})})
            .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw new Error(j.description || 'error'); return j; }); }).then(getCart);
        }
        req.then(function(cart){ track('mb_accessory_add',{item:a.title, variant:v.title}); fin(); openDrawer(cart); })
           .catch(function(e){ fin(); msg.textContent = 'We couldn\u2019t add that to your cart. Please try again.'; });
      });
      upd(); ag.appendChild(card);
    });
  }

  /* ---------- gallery ---------- */
  var g = $('#stage');
  if (g){
    // optional demo video as first slide
    var gid = ytId(M.demoVideo);
    if (M.demoVideo){
      var f = document.createElement('figure'); f.className='slide';
      if (gid){ f.className = 'slide yts'; f.appendChild(ytFacade(gid, M.demoPoster, 'MyoBuddy in use')); } else
      { f.innerHTML = '<video controls playsinline preload="metadata" poster="'+(M.demoPoster||'')+'"><source src="'+M.demoVideo+'" type="video/mp4">'+(M.demoCaptions?'<track kind="captions" srclang="en" label="English" src="'+M.demoCaptions+'" default>':'')+'</video><figcaption>MyoBuddy in use. Tap for sound.</figcaption>'; }
      g.insertBefore(f, g.firstChild);
      var tb = document.createElement('button'); tb.type='button'; tb.setAttribute('aria-label','Demo video');
      tb.innerHTML = '<img src="'+(M.demoPoster||C.thumb||'')+'" alt=""><span class="play">\u25B6</span>';
      $('.thumbs').insertBefore(tb, $('.thumbs').firstChild);
    }
    var slides = $$('.slide', g), thumbs = $$('.thumbs button'), cur = 0;
    function show(i){ cur=(i+slides.length)%slides.length; slides.forEach(function(s,k){ s.hidden = k!==cur; var v=$('video',s); if (v && k!==cur) v.pause(); }); thumbs.forEach(function(t,k){ t.setAttribute('aria-current', k===cur?'true':'false'); }); }
    $('.prev', g).addEventListener('click', function(){ show(cur-1); });
    $('.next', g).addEventListener('click', function(){ show(cur+1); });
    thumbs.forEach(function(t,k){ t.addEventListener('click', function(){ show(k); }); });
    show(0);
  }

  /* ---------- section media: swap photo for video when provided ---------- */
  $$('[data-video]').forEach(function(box){
    var src = M[box.getAttribute('data-video')]; if (!src) return;
    var poster = $('img', box) ? $('img', box).getAttribute('src') : '';
    var yid = ytId(src);
    if (yid){ var t = box.getAttribute('data-video-title') || 'MyoBuddy video'; box.innerHTML = ''; box.classList.add('has-yt'); box.appendChild(ytFacade(yid, poster, t));
      $$('[data-if-video="'+box.getAttribute('data-video')+'"]').forEach(function(e){ e.hidden = false; }); return; }
    var cap = M[box.getAttribute('data-video')+'Captions'];
    box.innerHTML = '<video controls playsinline preload="none" poster="'+poster+'"><source src="'+src+'" type="video/mp4">'+(cap?'<track kind="captions" srclang="en" label="English" src="'+cap+'" default>':'')+'</video>';
    $$('[data-if-video="'+box.getAttribute('data-video')+'"]').forEach(function(e){ e.hidden = false; });
  });

  /* ---------- press strip ---------- */
  var PR = window.MB_PRESS || {}, pr = $('#press');
  if (pr && ((PR.written||[]).length || PR.demoed)){
    pr.hidden = false;
    (PR.written||[]).forEach(function(p){ var li = document.createElement('li'); var a = document.createElement(p.url?'a':'span');
      if (p.url){ a.href = p.url; a.target = '_blank'; a.rel = 'noopener'; } a.textContent = p.name; li.appendChild(a);
      if (p.year){ var y = document.createElement('small'); y.textContent = p.year; li.appendChild(y); } $('.press-list', pr).appendChild(li); });
    $('.press-demo', pr).textContent = PR.demoed || '';
  }

  /* ---------- testimonial wall (Mill "What they're saying") ---------- */
  var RV = window.MB_REVIEWERS || [], RTc = window.MB_RATING || {}, wall = $('#wall');
  function el(tag, cls, txt){ var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  function srcLink(r){ if (!r.url) return el('span', 'src', r.source || ''); var a = el('a', 'src', r.source); a.href = r.url; a.target = '_blank'; a.rel = 'noopener'; return a; }
  var tiles = [];
  // 1. company tile (dark)
  tiles.push(function(){ var t = el('li','tile t-dark'); t.appendChild(el('p','t-kicker','Founded in Chicago')); t.appendChild(el('p','t-huge','2014')); t.appendChild(el('p','t-sub','Over a decade of home massage')); return t; });
  // 2. editorial tile: first reviewer with a publication (Wellness Mama)
  var ed = RV[0];
  if (ed) tiles.push(function(){ var t = el('li','tile t-editorial'); t.appendChild(el('p','t-pub', ed.source)); var q = el('blockquote','t-q', '\u201C' + ed.quote + '\u201D'); t.appendChild(q);
    var w = el('p','t-who'); w.appendChild(el('b',null, ed.name)); w.appendChild(el('span',null, ed.name === 'Katie Wells' ? 'Founder, Wellness Mama' : ed.source)); t.appendChild(w); t.appendChild(srcLink({source:'Read the article', url: ed.url})); return t; });
  // 3. rating tile
  if (RTc.average && RTc.count) tiles.push(function(){ var t = el('li','tile t-rating'); t.appendChild(el('p','t-avg', (+RTc.average).toFixed(1)));
    t.appendChild(el('p','t-cnt', (+RTc.count).toLocaleString('en-US') + ' reviews')); var s = el('p','t-stars'); s.innerHTML = starsHTML(+RTc.average); s.setAttribute('aria-hidden','true'); t.appendChild(s);
    t.appendChild(el('p','t-line','Rated by owners at myobuddy.com')); if (RTc.url){ var a = el('a','t-more','See all reviews'); a.href = RTc.url; a.target='_blank'; a.rel='noopener'; t.appendChild(a); } return t; });
  // 4. photo tile
  tiles.push(function(){ var t = el('li','tile t-photo'); var i = el('img'); i.src = C.wallPhoto || C.thumb; i.alt = 'Using MyoBuddy on the forearm after a workout'; i.loading='lazy'; t.appendChild(i);
    var c = el('div','t-cap'); c.appendChild(el('p','t-kicker','At home')); c.appendChild(el('p','t-title','A few minutes after a workout')); t.appendChild(c); return t; });
  // customer review tiles
  (R.filter(function(r){ return r.feature; }).concat(R.filter(function(r){ return !r.feature; }))).slice(0, 2).forEach(function(r){ tiles.push(function(){ var t = el('li','tile t-review'); var s = el('p','t-rstars', '\u2605'.repeat(r.rating||5)); s.setAttribute('aria-label', (r.rating||5)+' out of 5 stars'); t.appendChild(s);
    if (r.title) t.appendChild(el('p','t-rtitle', r.title)); t.appendChild(el('blockquote','t-q', '\u201C' + r.text + '\u201D'));
    var w = el('div','t-person'); w.appendChild(el('span','t-av', (r.name||'C').charAt(0))); var nm = el('p'); nm.appendChild(el('b',null, r.name)); nm.appendChild(el('span',null, (r.verified ? 'Verified buyer' : 'Customer') + (r.model ? ' \u00b7 MyoBuddy ' + r.model : ''))); w.appendChild(nm); t.appendChild(w); return t; }); });
  // reviewer tiles (the rest)
  RV.slice(1).forEach(function(r, k){ tiles.push(function(){ var t = el('li','tile ' + (k === 0 ? 't-feature' : 't-quote'));
    if (k === 0){ var i = el('img','t-img'); i.src = C.wallPhoto2 || C.thumb; i.alt = ''; i.loading = 'lazy'; t.appendChild(i); }
    var q = el('blockquote','t-q', '\u201C' + r.quote + '\u201D'); if (window.MB_REVIEWERS_NOTE) q.appendChild(sup(footnote(window.MB_REVIEWERS_NOTE))); t.appendChild(q);
    var w = el('p','t-who'); w.appendChild(el('b',null, r.name)); var line = el('span','t-src'); line.appendChild(srcLink(r)); if (r.free){ line.appendChild(el('span','disc','Sponsored')); } w.appendChild(line); t.appendChild(w); return t; }); });
  if (wall){
    // balanced columns: each tile goes into the currently shortest column, then the last tile
    // in every column stretches so all columns end at the same line
    var made = tiles.map(function(f){ return f(); }), grid = el('div','wall-grid');
    var wallNav = el('div','car-nav wall-nav'); wallNav.hidden = true;
    wallNav.innerHTML = '<button type="button" class="car-prev" aria-label="Previous reviews">&lsaquo;</button><button type="button" class="car-next" aria-label="More reviews">&rsaquo;</button>';
    wall.appendChild(wallNav); wall.appendChild(grid);
    function wallStep(){ var t = grid.firstElementChild; return t ? t.getBoundingClientRect().width + 12 : 300; }
    function wallUpd(){ var p = $('.car-prev', wallNav), q = $('.car-next', wallNav); p.disabled = grid.scrollLeft <= 2; q.disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2; }
    $('.car-prev', wallNav).addEventListener('click', function(){ grid.scrollBy({left: -wallStep(), behavior: 'smooth'}); });
    $('.car-next', wallNav).addEventListener('click', function(){ grid.scrollBy({left: wallStep(), behavior: 'smooth'}); });
    grid.addEventListener('scroll', function(){ requestAnimationFrame(wallUpd); }, {passive: true}); setTimeout(wallUpd, 60);
    var order = [0, 1, 4, 2, 6, 7, 3, 5, 8, 9], curN = 0;
    function ncols(){ var w = wall.clientWidth || window.innerWidth; return w > 1060 ? 4 : (w > 700 ? 3 : (window.innerWidth < 560 ? 1 : 2)); }
    function lay(force){
      var n = ncols(); if (n === curN && !force) return; curN = n;
      grid.classList.toggle('swipe', n === 1); if (wallNav) wallNav.hidden = n !== 1;
      if (n === 1){ grid.innerHTML = ''; var seq1 = order.filter(function(i){ return i < made.length; }).map(function(i){ return made[i]; });
        made.forEach(function(t){ if (seq1.indexOf(t) < 0) seq1.push(t); }); seq1.forEach(function(t){ grid.appendChild(t); }); return; }
      var seq = order.filter(function(i){ return i < made.length; }).map(function(i){ return made[i]; });
      made.forEach(function(t){ if (seq.indexOf(t) < 0) seq.push(t); });
      grid.classList.add('laying'); grid.innerHTML = ''; var cols = [];
      function h(c){ var l = c.lastElementChild; return l ? l.getBoundingClientRect().bottom - c.getBoundingClientRect().top : 0; }
      for (var i = 0; i < n; i++){ var c = el('ul','wall-col'); grid.appendChild(c); cols.push(c); }
      seq.forEach(function(t, k){
        var target = k < n ? cols[k] : cols.reduce(function(a, b){ return h(b) < h(a) - 1 ? b : a; });
        target.appendChild(t);
      });
      grid.classList.remove('laying');
    }
    lay(true);
    var rz; window.addEventListener('resize', function(){ clearTimeout(rz); rz = setTimeout(function(){ lay(false); }, 120); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ lay(true); });
    window.addEventListener('load', function(){ lay(true); });
  }
  var rv = $('#reviews');
  if (rv && !tiles.length){ rv.hidden = true; }

  /* ---------- customer reviews list (bottom of page, like Mill PDP) ---------- */
  var cs = $('#customer-reviews'), cust = $('#cust');
  if (cs && R.length){
    cs.hidden = false;
    var avgC = RTc.average || (R.length ? R.reduce(function(s,r){ return s + (r.rating||0); },0)/R.length : 0);
    var cntC = RTc.count || R.length;
    $('#cr-avg').textContent = (+avgC).toFixed(1);
    $('#cr-stars').innerHTML = starsHTML(+avgC);
    $('#cr-count').textContent = 'Based on ' + (+cntC).toLocaleString('en-US') + ' reviews';
    if (RTc.url){ $('#cr-write').href = RTc.url; $('#cr-all').href = RTc.url; $('#cr-all').textContent = 'See all ' + (+cntC).toLocaleString('en-US') + ' reviews'; }
    else { $('#cr-write').hidden = true; $('#cr-all').hidden = true; }
    var ul2 = $('.cr-list', cust);
    R.forEach(function(r){
      var li = document.createElement('li');
      li.innerHTML = '<div class="top"><span class="st" aria-hidden="true"></span><b class="nm"></b><span class="vf" hidden>Verified</span><span class="dt"></span></div><p class="ttl"></p><p class="tx"></p><p class="for" hidden>Review for: <span></span></p>';
      $('.st', li).textContent = '\u2605'.repeat(r.rating||5); li.setAttribute('aria-label', (r.rating||5) + ' out of 5 stars');
      $('.nm', li).textContent = r.name || 'Customer'; if (r.verified) $('.vf', li).hidden = false;
      $('.dt', li).textContent = r.date || '';
      if (r.title) $('.ttl', li).textContent = r.title; else $('.ttl', li).remove();
      $('.tx', li).textContent = r.text;
      if (r.model){ $('.for', li).hidden = false; $('.for span', li).textContent = 'MyoBuddy ' + r.model; }
      if (ul2.children.length >= 5) li.hidden = true;
      ul2.appendChild(li);
    });
    if (R.length > 5){
      var more = el('button','btn light cr-more','Show more reviews'); more.type = 'button';
      more.addEventListener('click', function(){ $$('li[hidden]', ul2).forEach(function(x){ x.hidden = false; }); more.remove(); track('mb_reviews_more'); });
      ul2.parentNode.appendChild(more);
    }
  }

  /* ---------- trusted voices ---------- */
  var VO = (window.MB_VOICES || []).filter(function(v){ return v.approved !== false; }), vs = $('#voices');
  if (vs && VO.length){
    vs.hidden = false;
    VO.forEach(function(v){
      var li = document.createElement('li');
      li.innerHTML = '<div class="ph"><img alt="" loading="lazy"></div><div class="tx"><blockquote></blockquote><div class="who"><p class="nm"></p><p class="tt"></p></div></div>';
      $('img', li).src = v.photo; $('img', li).alt = v.name;
      $('blockquote', li).textContent = '\u201C' + v.quote + '\u201D';
      $('.nm', li).textContent = v.name; $('.tt', li).textContent = v.title;
      if (v.label){ var d = document.createElement('span'); d.className = 'disc'; d.textContent = v.label; $('.tt', li).appendChild(d); }
      if (v.footnote) $('blockquote', li).appendChild(sup(footnote(v.footnote)));
      $('#voice-list').appendChild(li);
    });
  }

  /* ---------- carousels ---------- */
  $$('[data-carousel]').forEach(function(c){
    var t = $('.car-track', c), prev = $('.car-prev', c), next = $('.car-next', c);
    if (!t || !prev || c.hasAttribute('data-marquee')) return;
    function step(){ var li = $('li', t); return li ? li.getBoundingClientRect().width + 14 : 300; }
    function upd(){ prev.disabled = t.scrollLeft <= 2; next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
      $('.car-nav', c).hidden = t.scrollWidth <= t.clientWidth + 2; }
    prev.addEventListener('click', function(){ t.scrollBy({left: -step(), behavior: 'smooth'}); });
    next.addEventListener('click', function(){ t.scrollBy({left: step(), behavior: 'smooth'}); });
    t.addEventListener('scroll', function(){ requestAnimationFrame(upd); }, {passive: true});
    window.addEventListener('resize', upd); setTimeout(upd, 50);
  });

  /* ---------- rating line: theme MB_RATING > Shopify review metafields > on-page reviews ---------- */
  var RT = window.MB_RATING || {}, rating = null;
  if (RT.average && RT.count) rating = {avg: +RT.average, count: +RT.count, url: RT.url};
  else if (C.shopRating && C.shopRating.average && C.shopRating.count) rating = {avg: +C.shopRating.average, count: +C.shopRating.count, url: RT.url};
  else { var rated = R.filter(function(r){ return typeof r.rating === 'number'; });
    if (rated.length) rating = {avg: rated.reduce(function(s,r){ return s + r.rating; }, 0) / rated.length, count: rated.length, url: '#reviews'}; }
  if (rating){
    $$('[data-rating]').forEach(function(el){
      el.hidden = false; $('.rt-n', el).textContent = rating.avg.toFixed(1) + ' / 5';
      $('.rt-s', el).innerHTML = '<span class="bg">\u2605\u2605\u2605\u2605\u2605</span><span class="fg" style="width:' + (rating.avg/5*100).toFixed(1) + '%">\u2605\u2605\u2605\u2605\u2605</span>';
      $('.rt-c', el).textContent = rating.count.toLocaleString('en-US') + (rating.count === 1 ? ' review' : ' reviews');
      el.setAttribute('aria-label', 'Rated ' + rating.avg.toFixed(1) + ' out of 5 based on ' + rating.count + ' reviews');
      if (rating.url){ el.href = rating.url; if (/^https?:/.test(rating.url)){ el.target = '_blank'; el.rel = 'noopener'; } }
      el.addEventListener('click', function(){ track('mb_rating_click'); });
    });
  }

  /* ---------- menu overlay ---------- */
  var menu = $('#menu'), mbtn = $('.menu-btn'), mscrim = $('#menu-scrim');
  if (menu && mbtn){
    function place(){ var r = mbtn.getBoundingClientRect(); menu.style.top = Math.max(4, r.top - 12) + 'px'; menu.style.right = Math.max(4, window.innerWidth - r.right - 12) + 'px'; }
    window.addEventListener('resize', function(){ if (!menu.hidden) place(); });
    function openMenu(){ place(); menu.hidden = false; requestAnimationFrame(function(){ menu.classList.add('show'); mscrim.classList.add('show'); });
      mbtn.setAttribute('aria-expanded','true'); document.documentElement.classList.add('mb-lock'); $('.menu-x', menu).focus(); }
    function closeMenu(back){ menu.classList.remove('show'); mscrim.classList.remove('show'); mbtn.setAttribute('aria-expanded','false');
      document.documentElement.classList.remove('mb-lock'); setTimeout(function(){ menu.hidden = true; }, 200); if (back !== false) mbtn.focus(); }
    mbtn.addEventListener('click', openMenu);
    $('.menu-x', menu).addEventListener('click', function(){ closeMenu(); });
    mscrim.addEventListener('click', function(){ closeMenu(); });
    $$('a', menu).forEach(function(a){ a.addEventListener('click', function(){ closeMenu(false); }); });
    document.addEventListener('keydown', function(e){
      if (menu.hidden) return;
      if (e.key === 'Escape') closeMenu();
      if (e.key === 'Tab'){ var f = $$('button, a:not([hidden])', menu).filter(function(x){ return x.offsetParent !== null; }); var first = f[0], last = f[f.length-1];
        if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); } else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); } }
    });
  }

  /* ---------- links between the two pages ---------- */
  function inMarketingFunnel(){ return ss.get('mb_funnel') === 'marketing' || (C.lpTag && String(C.lpTag).indexOf('lp-marketing') === 0); }
  function linkBase(which){
    if (inMarketingFunnel()){
      var purchase = ss.get('mb_marketing_purchase');
      if (which === 'home' && (L.marketingHome || L.home)) return L.marketingHome || L.home;
      if (which === 'purchase' && purchase) return purchase.split('#')[0];
      if (which === 'explain' && purchase) return marketingExplain(purchase);
    }
    return L[which];
  }
  function gotoHref(which){
    var base = linkBase(which); if (!base) return null;
    var p = new URLSearchParams(), m = models[sel];
    if (m) p.set('model', m.key); if (qty>1) p.set('qty', qty);
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(function(k){ var v = qs0.get(k) || ss.get('mb_'+k); if (v) p.set(k, v); });
    var q = p.toString(); return base + (q ? (base.indexOf('?')<0 ? '?' : '&') + q : '');
  }
  function gotoFull(a){ var h = gotoHref(a.getAttribute('data-goto')); var hs = a.getAttribute('data-hash'); return h + (hs ? '#' + hs : ''); }
  $$('[data-goto]').forEach(function(a){
    var which = a.getAttribute('data-goto');
    if (!linkBase(which)){ a.hidden = true; return; }
    function upd(){ a.href = gotoFull(a); }
    upd(); a.addEventListener('mouseenter', upd); a.addEventListener('focus', upd);
    a.addEventListener('click', function(){ upd(); track('mb_switch_page',{to: which, model: (models[sel]||{}).label}); });
  });

  /* ---------- manual link ---------- */
  $$('[data-manual]').forEach(function(a){ if (M.manualUrl){ a.href = M.manualUrl; a.target='_blank'; a.rel='noopener'; } else { a.outerHTML = '<span>' + (a.getAttribute('data-manual')==='footer' ? 'User guide: printed, in the box' : 'the printed user guide in the box') + '</span>'; } });

  /* ---------- spec columns / model cards: only models on sale ---------- */
  var onSale = models.map(function(m){ return m.key; });
  $$('[data-model-col]').forEach(function(e){ if (onSale.indexOf(e.getAttribute('data-model-col')) < 0) e.hidden = true; });
  var sc = $('.sc-cols'); if (sc) sc.style.setProperty('--cols', Math.max(1, onSale.length));
  $$('.sp-row, .cmp-row').forEach(function(r){ r.style.setProperty('--cols', Math.max(1, onSale.length)); });
  var mc2 = $('#mcards');
  if (mc2){
    var perks = {pro: ['3 speeds on one button', 'Same 6-inch padded disk', 'Powers on at low'], elite: ['15 levels with + and \u2212', 'Same 6-inch padded disk', 'Powers on at medium']};
    models.forEach(function(m){
      var card = document.createElement('div'); card.className = 'mcard';
      var img = (C.modelLarge||{})[m.key] || m.image || C.thumb;
      card.innerHTML = '<div class="mc-img"><img alt="" loading="lazy"></div><div class="mc-b"><h3></h3><p class="mc-pr"></p><ul></ul><button class="btn" type="button" data-buy data-model="'+m.key+'" data-label="Buy">Buy</button></div>';
      $('img', card).src = img; $('img', card).alt = 'MyoBuddy ' + m.label; $('h3', card).textContent = 'MyoBuddy ' + m.label; $('.mc-pr', card).textContent = m.price;
      (perks[m.key]||[]).forEach(function(t){ var li = document.createElement('li'); li.textContent = t; $('ul', card).appendChild(li); });
      if (m.available === false){ var bt = $('button', card); bt.disabled = true; bt.textContent = 'Sold out'; }
      bindBuy($('button', card));
      mc2.appendChild(card);
    });
  }
  var rtI = window.MB_RATING || {};
  $$('[data-rating-inline]').forEach(function(a){ if (rtI.average && rtI.count){ a.textContent = (+rtI.average).toFixed(1) + ' \u2605 ' + (+rtI.count).toLocaleString('en-US') + ' reviews'; } else { a.remove(); } });

  /* ---------- phones: shorter comparison + specs ---------- */
  var fm = $('.fmt-more');
  if (fm){ fm.addEventListener('click', function(){ var f = $('.fmt'); var open = !f.classList.contains('expanded');
    f.classList.toggle('expanded', open); fm.setAttribute('aria-expanded', open ? 'true' : 'false'); fm.textContent = open ? 'Show less' : 'Show the full comparison';
    if (!open) f.scrollIntoView({block:'start'}); track('mb_fmt_more', {open: open}); }); }
  if (window.matchMedia('(max-width:760px)').matches){ $$('#compare details.acc').forEach(function(d, i){ if (i > 0) d.open = false; }); }

  /* ---------- tabs (See the surface. Watch the motion.) ---------- */
  $$('[data-tabs]').forEach(function(list){
    var tabs = $$('[role=tab]', list);
    function sel(t, focus){
      tabs.forEach(function(x){ var on = x === t; x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1;
        var p = document.getElementById(x.getAttribute('aria-controls')); if (p){ p.hidden = !on; if (on){ p.classList.remove('in'); void p.offsetWidth; p.classList.add('in'); } } });
      if (focus) t.focus(); track('mb_tab', {tab: t.id});
    }
    tabs.forEach(function(t, i){
      t.addEventListener('click', function(){ sel(t); });
      t.addEventListener('keydown', function(e){
        var k = e.key, n = null;
        if (k === 'ArrowRight') n = tabs[(i + 1) % tabs.length]; else if (k === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (k === 'Home') n = tabs[0]; else if (k === 'End') n = tabs[tabs.length - 1];
        if (n){ e.preventDefault(); sel(n, true); }
      });
    });
  });

  /* ---------- compare popup (Mill "Compare models") ---------- */
  var cm = $('#cmodal'), cms = $('#cm-scrim'), cmLast = null;
  if (cm){
    function cmOpen(){ cmLast = document.activeElement; cm.hidden = false; requestAnimationFrame(function(){ cm.classList.add('show'); cms.classList.add('show'); });
      document.documentElement.classList.add('mb-lock'); $('.cm-x', cm).focus(); track('mb_compare_open'); }
    function cmClose(){ cm.classList.remove('show'); cms.classList.remove('show'); document.documentElement.classList.remove('mb-lock');
      setTimeout(function(){ cm.hidden = true; }, 200); if (cmLast) cmLast.focus(); }
    $$('[data-open-compare]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); setTimeout(cmOpen, b.closest('#menu') ? 220 : 0); }); });
    $('.cm-x', cm).addEventListener('click', cmClose); cms.addEventListener('click', cmClose);
    document.addEventListener('keydown', function(e){
      if (cm.hidden) return;
      if (e.key === 'Escape') cmClose();
      if (e.key === 'Tab'){ var f = $$('button, a', cm).filter(function(x){ return x.offsetParent !== null; }); var first = f[0], last = f[f.length-1];
        if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); } else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); } }
    });
    $$('[data-choose]', cm).forEach(function(b){ b.addEventListener('click', function(){
      var k = b.getAttribute('data-choose'); chosen = true; models.forEach(function(x,i){ if (x.key === k && x.available !== false) sel = i; }); syncModelUrl(models[sel]);
      paint(); track('mb_compare_choose', {model: k}); cmClose();
      var bb = $('#buy'); if (bb && window.innerWidth <= 920) bb.scrollIntoView({behavior:'smooth', block:'start'});
    }); });
    $$('.cmp-row', cm).forEach(function(r){ r.style.setProperty('--cols', Math.max(1, models.length)); });
  }

  /* ---------- marquee helpers ---------- */
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* "Written about in": CSS marquee on phones */
  var pl = $('.press-list');
  if (pl && !reduced){
    var plOrig = pl.innerHTML, mqP = window.matchMedia('(max-width:760px)');
    function pressMode(){
      if (mqP.matches){
        pl.innerHTML = plOrig + plOrig.replace(/<li/g, '<li aria-hidden="true"');
        $$('li[aria-hidden] a', pl).forEach(function(a){ a.tabIndex = -1; });
        pl.classList.add('marq');
      } else { pl.innerHTML = plOrig; pl.classList.remove('marq'); }
    }
    pressMode(); if (mqP.addEventListener) mqP.addEventListener('change', pressMode);
  }

  /* endorsements: auto-scrolling marquee, drag to scroll, arrows take over (and stop it) */
  $$('[data-marquee]').forEach(function(c){
    var t = $('.car-track', c), prev = $('.car-prev', c), next = $('.car-next', c);
    if (!t || !t.children.length) return;
    var n0 = t.children.length;
    Array.prototype.slice.call(t.children).forEach(function(li){ var k = li.cloneNode(true); k.setAttribute('aria-hidden', 'true'); if (k.id) k.removeAttribute('id'); k.querySelectorAll('[id]').forEach(function(e){ e.removeAttribute('id'); }); k.querySelectorAll('a,button').forEach(function(e){ e.tabIndex = -1; }); t.appendChild(k); });
    t.classList.add('marq');
    var auto = !reduced, paused = false, stopped = false, pos = 0, last = 0, half = 0;
    function measure(){ half = t.children[n0].offsetLeft - t.children[0].offsetLeft; }
    measure(); window.addEventListener('resize', measure);
    function wrap(){ if (half > 0){ if (t.scrollLeft >= half) t.scrollLeft -= half; else if (t.scrollLeft <= 0 && pos < 0) t.scrollLeft += half; } }
    function tick(ts){
      if (!last) last = ts; var dt = Math.min(48, ts - last); last = ts;
      if (auto && !paused && !stopped && !dragging){ pos = t.scrollLeft + dt * 0.035; t.scrollLeft = pos; if (half && t.scrollLeft >= half) t.scrollLeft -= half; }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
    t.addEventListener('mouseenter', function(){ paused = true; });
    t.addEventListener('mouseleave', function(){ paused = false; });
    var resumeT;
    t.addEventListener('touchstart', function(){ paused = true; clearTimeout(resumeT); }, {passive: true});
    t.addEventListener('touchend', function(){ clearTimeout(resumeT); resumeT = setTimeout(function(){ paused = false; }, 2500); }, {passive: true});
    t.addEventListener('scroll', function(){ if (half && (t.scrollLeft >= half || t.scrollLeft <= 1)) { if (t.scrollLeft >= half) t.scrollLeft -= half; else t.scrollLeft += half; } }, {passive: true});
    // mouse drag
    var dragging = false, sx = 0, sl = 0, moved = false;
    t.addEventListener('pointerdown', function(e){ if (e.pointerType !== 'mouse') return; dragging = true; moved = false; sx = e.clientX; sl = t.scrollLeft; t.classList.add('grab'); t.setPointerCapture(e.pointerId); });
    t.addEventListener('pointermove', function(e){ if (!dragging) return; var dx = e.clientX - sx; if (Math.abs(dx) > 3) moved = true; t.scrollLeft = sl - dx; });
    function endDrag(){ dragging = false; t.classList.remove('grab'); }
    t.addEventListener('pointerup', endDrag); t.addEventListener('pointercancel', endDrag);
    t.addEventListener('click', function(e){ if (moved){ e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    function step(){ var li = t.children[0]; return li ? li.getBoundingClientRect().width + 14 : 300; }
    function manual(dir){ stopped = true; c.classList.add('manual'); t.scrollBy({left: dir * step(), behavior: 'smooth'}); track('mb_voices_arrow', {dir: dir}); }
    if (prev) prev.addEventListener('click', function(){ manual(-1); });
    if (next) next.addEventListener('click', function(){ manual(1); });
    if (prev) { prev.disabled = false; next.disabled = false; }
    c._marquee = { isStopped: function(){ return stopped; }, isAuto: function(){ return auto; } };
  });

  /* FAQ: show five questions, the rest on request (deep links still open their answer) */
  $$('.faqs').forEach(function(fq){
    var items = $$('details.q', fq); if (items.length <= 6) return;
    var extra = items.slice(5); extra.forEach(function(d){ d.hidden = true; });
    var btn = el('button', 'btn light faq-more', 'Show ' + extra.length + ' more questions'); btn.type = 'button'; btn.setAttribute('aria-expanded', 'false');
    fq.appendChild(btn);
    function showAll(){ extra.forEach(function(d){ d.hidden = false; }); btn.remove(); }
    btn.addEventListener('click', function(){ showAll(); if (extra[0]) { var s = $('summary', extra[0]); s && s.focus(); } track('mb_faq_more'); });
    function openHash(){ var h = location.hash.slice(1); if (!h) return; var d = document.getElementById(h);
      if (d && extra.indexOf(d) >= 0){ showAll(); d.open = true; setTimeout(function(){ d.scrollIntoView({block: 'start'}); }, 30); } else if (d && d.tagName === 'DETAILS') d.open = true; }
    openHash(); window.addEventListener('hashchange', openHash);
    fq.addEventListener('click', function(){}, false);
  });

  /* ---------- footnotes (very small, bottom of page) ---------- */
  var fnl = $('#footnotes');
  if (fnl && FN.length){ fnl.hidden = false; FN.forEach(function(t, i){ var li = document.createElement('li'); li.id = 'fn-' + (i+1); li.textContent = t; fnl.appendChild(li); }); }

  /* ---------- current page link: back to the top ---------- */
  $$('[data-top]').forEach(function(a2){
    a2.addEventListener('click', function(e){ e.preventDefault(); window.scrollTo({top: 0, behavior: 'smooth'});
      var mn = $('#menu'); if (mn && !mn.hidden){ var x = $('.menu-x'); if (x) x.click(); } });
  });

  /* ---------- header: white on hover/focus/scroll-up, hides on scroll-down (Mill) ---------- */
  var hdr = $('#hdr');
  if (hdr){
    var lastY = window.scrollY, hov = false, tk = false;
    function hstate(){
      tk = false;
      var y = window.scrollY, menuOpen = document.documentElement.classList.contains('mb-lock');
      var down = y > lastY + 2, up = y < lastY - 2;
      if (y < 12){ hdr.classList.remove('hide'); }
      else if (down && y > 140 && !hov && !menuOpen){ hdr.classList.add('hide'); }
      else if (up){ hdr.classList.remove('hide'); }
      hdr.classList.toggle('solid', hov || y >= 12 || hdr.contains(document.activeElement));
      lastY = y;
    }
    window.addEventListener('scroll', function(){ if (!tk){ tk = true; requestAnimationFrame(hstate); } }, {passive:true});
    hdr.addEventListener('mouseenter', function(){ hov = true; hstate(); });
    hdr.addEventListener('mouseleave', function(){ hov = false; hstate(); });
    hdr.addEventListener('focusin', function(){ hdr.classList.remove('hide'); hstate(); });
    hdr.addEventListener('focusout', function(){ setTimeout(hstate, 0); });
    hstate();
  }

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    var rvSel = '.sec h2:not(.vh), .sec .lede, .split > *, .cards > .card, .st-tabs, .st-panels, .fmt, .kitbox, .acc-card, .car-track, .wall-col > .tile, .creviews > *, .specs, .final, .facts-strip > li, .press .wrap';
    var vh = window.innerHeight, rvEls = $$(rvSel).filter(function(e){ return e.getBoundingClientRect().top > vh * 0.9; });
    var io = new IntersectionObserver(function(es){ es.forEach(function(en){ if (en.isIntersecting){ en.target.classList.add('rv-in'); io.unobserve(en.target); } }); }, {rootMargin:'0px 0px -8% 0px', threshold:0.08});
    rvEls.forEach(function(e){
      var sib = e.parentNode ? Array.prototype.indexOf.call(e.parentNode.children, e) : 0;
      e.style.transitionDelay = Math.min(sib, 4) * 70 + 'ms';
      e.classList.add('rv'); io.observe(e);
    });
    // safeguard: anything already on screen (or a page shown without scrolling) always appears
    function revealVisible(){ var vh2 = window.innerHeight; $$('.rv:not(.rv-in)').forEach(function(e){ var r = e.getBoundingClientRect(); if (r.top < vh2 && r.bottom > 0) e.classList.add('rv-in'); }); }
    setTimeout(revealVisible, 1200); setTimeout(revealVisible, 3000); window.addEventListener('resize', revealVisible);
  }

  /* ---------- sticky bar ---------- */
  var st = $('#sticky'), anchor = $('[data-sticky-anchor]') || $('#buy [data-buy]'), endA = $('#final');
  if (st && anchor){
    var ticking = false;
    function u(){ ticking = false;
      var ar = anchor.getBoundingClientRect(), vh = window.innerHeight;
      var passed = ar.bottom < 0;                       // initial buying section has left view (scrolled past)
      var endVis = false; if (endA){ var er = endA.getBoundingClientRect(); endVis = er.top < vh && er.bottom > 0; }
      var bb = $('#buy'), bbVis = false; if (bb && bb !== anchor.closest('#buy')){ var br = bb.getBoundingClientRect(); bbVis = br.top < vh && br.bottom > 0; }
      var s = passed && !endVis && !bbVis && !(drawer && drawer.classList.contains('show'));
      st.classList.toggle('show', s); st.setAttribute('aria-hidden', s?'false':'true'); $('.btn', st).tabIndex = s?0:-1; document.body.classList.toggle('mb-sticky-on', s); }
    function req(){ if (!ticking){ ticking = true; requestAnimationFrame(u); } }
    window.addEventListener('scroll', req, {passive:true}); window.addEventListener('resize', req); u();
  }
})();
